import { BaseComponent } from '@pixelart/component-handler';

export class MainNav extends BaseComponent {
    protected MAIN_ITEM_SELECTOR: string = '.mainnav__item';
    protected MAIN_ITEM_LINK_SELECTOR: string = '.mainnav__item-link';
    protected MAIN_ITEM_ACTIVE_CLASS: string = 'mainnav--item-active';
    protected MAIN_ITEM_HAS_SUBMENU_CLASS: string = 'mainnav--has-submenu';
    protected MOBILE_TOGGLE_SELECTOR: string = '.mainnav__mobile-toggle';
    protected MOBILE_ACTIVE_CLASS: string = 'mainnav--mobile-active';
    protected BODY_ACTIVE_CLASS: string = 'mainnav--body-mobile-active';
    private $mobileToggle: JQuery;
    private itemIsActive: boolean = false;

    public constructor(element: Element) {
        super(element);
        this.$mobileToggle = this.$element.find(this.MOBILE_TOGGLE_SELECTOR);
    }

    public init() {
        this.setListeners();
    }

    private setListeners() {
        $(this.element).on('click', this.MAIN_ITEM_LINK_SELECTOR, (e) => {
            const $menuItem: JQuery = $(e.currentTarget).closest(this.MAIN_ITEM_SELECTOR);

            if (!this.isActiveItem($menuItem) && this.hasSubmenu($menuItem)) {
                this.deactivateAllItems();
                this.setItemActive($menuItem);

                e.preventDefault();
            }
        });

        this.$mobileToggle.on('click', (e) => {
            $(this.element).toggleClass(this.MOBILE_ACTIVE_CLASS);
            $('body').toggleClass(this.BODY_ACTIVE_CLASS);

            e.preventDefault();
        });

        /**
         * close menu when clicking outside
         */
        $('body').on('click', (e) => {
            if (this.itemIsActive && $(e.target).parents(this.MAIN_ITEM_SELECTOR).length <= 0) {
                this.deactivateAllItems();
            }
        });
    }

    private isActiveItem($item: JQuery): boolean {
        return $item.hasClass(this.MAIN_ITEM_ACTIVE_CLASS);
    }

    private hasSubmenu($item: JQuery): boolean {
        return $item.hasClass(this.MAIN_ITEM_HAS_SUBMENU_CLASS);
    }

    private setItemActive($item: JQuery) {
        $item.addClass(this.MAIN_ITEM_ACTIVE_CLASS);
        this.itemIsActive = true;
    }

    private setItemInactive($item: JQuery) {
        $item.removeClass(this.MAIN_ITEM_ACTIVE_CLASS);
        this.itemIsActive = false;
    }

    private deactivateAllItems() {
        $(this.element).find(this.MAIN_ITEM_SELECTOR).each((idx, $item) => {
            this.setItemInactive($($item) as JQuery);
        });
        this.itemIsActive = false;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/mainnav/mainnav.class.ts